import {
  createCoachInterfaceIntroDesktopSteps,
  type DesktopTourStepCopy,
} from './coachInterfaceIntroDesktopSteps';
import { createCoachInterfaceIntroMobileSteps } from './coachInterfaceIntroMobileSteps';
import type { TourStepFactoryContext, TourVariant } from './types';

const createCoachInterfaceIntroCopy = (
  variant: TourVariant,
  translate: TourStepFactoryContext['translate'],
): DesktopTourStepCopy => {
  const copyKey = `coachInterfaceIntro.${variant}`;

  return {
    welcomeTitle: translate(`${copyKey}.welcome.title`),
    welcomeDescription: translate(`${copyKey}.welcome.description`),
    scopeTitle: translate(`${copyKey}.scope.title`),
    scopeDescription: translate(`${copyKey}.scope.description`),
    sidebarTitle: translate(`${copyKey}.sidebar.title`),
    sidebarDescription: translate(`${copyKey}.sidebar.description`),
    savedPromptsTitle: translate(`${copyKey}.savedPrompts.title`),
    savedPromptsDescription: translate(`${copyKey}.savedPrompts.description`),
    coachSuggestionsTitle: translate(`${copyKey}.coachSuggestions.title`),
    coachSuggestionsDescription: translate(
      `${copyKey}.coachSuggestions.description`,
    ),
    settingsTitle: translate(`${copyKey}.settings.title`),
    settingsDescription: translate(`${copyKey}.settings.description`),
    composerTitle: translate(`${copyKey}.composer.title`),
    composerDescription: translate(`${copyKey}.composer.description`),
    historyTitle: translate(`${copyKey}.history.title`),
    historyDescription: translate(`${copyKey}.history.description`),
    closingTitle: translate(`${copyKey}.closing.title`),
    closingDescription: translate(`${copyKey}.closing.description`),
  };
};

export const createCoachInterfaceIntroSteps = ({
  controller,
  translate,
  variant,
}: TourStepFactoryContext) => {
  if (!controller) {
    return undefined;
  }

  const copy = createCoachInterfaceIntroCopy(variant, translate);
  return variant === 'desktop'
    ? createCoachInterfaceIntroDesktopSteps({ controller, copy })
    : createCoachInterfaceIntroMobileSteps({ controller, copy });
};